import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ButtonItem } from "../../../../../entities/UIEntities/ButtonItem";
import { StepHeaderEntity } from "../../../../../entities/UIEntities/Form Entities/StepHeaderEntity";
import {
  ADD_PARKER_FORM_STEPS,
  INPUTS_PROPS,
} from "../../../../../enums/Enums";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import store from "../../../../../redux/Store";
import Icons from "../../../../../resources/icons/Icons";
import Strings from "../../../../../resources/Strings";
import { getProgressBarValue } from "../../../../../utils/CommonUtils";
import { isRequired } from "../../../../../utils/FormUtils";
import UserTypesButtons from "../../../Buttons/CustomToggleButton/UserTypesButtons/UserTypesButtons";
import FacilityUserTypesCard from "../../../Cards/FacilityUserTypesCard/FacilityUserTypesCard";
import classes from "../WizardForm.module.css";

const UserTypeStep = (props) => {
  const currentSites = useSelector((state) => state.user.selectedSites);
  const userTypes = useSelector((state) => state.user?.initialState?.userTypes);
  const [errors, setErrors] = useState({});
  const [siteValue, setSiteValue] = useState();
  const [userTypeValue, setUserTypeValue] = useState();

  
  // sitesToShow will be the remaining available sites that can be added
  // by excluding the already associated userSites from currentSites
  // support fromGmt case and regular case
  // if from allocation form - do the opposite - show the existing available sites as sites to show
  const userSites = props?.fromGmt ? props?.exsistUserEntity?.userSites : props?.userSites;
  

  // check from the user's userToUserType against userSites - which sites to prepare to show
  // represents the relevant sites & user types for the selected user
  const relevantUserToUserTypes = props?.userData?.utronUser?.userToUserTypes?.map(ut => ut?.userType)?.filter(ut => userSites?.some(us => us.siteId === ut.siteId));

  //const sitesToShow = currentSites;
  // isEditMode - from Facility, isAddAllocationProcess - from allocation, the rest, add new parker
  const sitesToShow = !props?.isAddAllocationProcess || props?.isEditMode ? 
  currentSites : // example: in manage facility / add new parker 
  currentSites?.filter(cs => relevantUserToUserTypes?.some(ut => ut.siteId === cs.id)); // example: in add allocation

  // on allocation - show user's relevant user types, from the rest (new parker, facillity) show all user types
  const buttonsList = !props?.isAddAllocationProcess || props?.isEditMode ? 
  userTypes?.filter((userType) => userType.siteId === siteValue)?.map(
    (userType) => new ButtonItem(userType.id, userType.type)
  ) :
  relevantUserToUserTypes?.filter((userType) => userType.siteId === siteValue)?.map(
    (userType) => new ButtonItem(userType.id, userType.type)
  );
  
  useEffect(() => {
    handleUserTypeChange(null, "");
  }, [siteValue]);

  useEffect(() => {
    if (props.currentStep === ADD_PARKER_FORM_STEPS.USER_TYPE) {
      const hasError = Object.values(errors).some((error) => !error.isValid);
      props.handleCurrentStepValidity(hasError);
    }
  }, [errors]);

  useEffect(() => {
    validateStep();
  }, [siteValue, userTypeValue, props.currentStep]);

  useEffect(() => {
    // auto-select the founded userTypes
    let foundedUserType = props?.userToUserTypes?.find(ut => ut?.userType?.siteId === siteValue) ? 
    props?.userToUserTypes?.find(ut => ut?.userType?.siteId === siteValue)?.userTypeId : null;
    if (foundedUserType !== null) {
      handleUserTypeChange(null, foundedUserType);
    }
  }, [siteValue]);

  useEffect(() => {
    if(props.stepHeader){
      store.dispatch(commonActions.setSideModal({ modalHeader: props.stepHeader }));
    }
    else if (props.currentStep === ADD_PARKER_FORM_STEPS.USER_TYPE) {
      const stepHeader = new StepHeaderEntity(
        props.isEditMode
          ? Strings.STEPS_TITLES.USER_TYPE_EDIT_MODAL_TITLE
          : Strings.STEPS_TITLES.USER_TYPE_MODAL_TITLE,
        props.isEditMode
          ? ""
          : Strings.STEPS_TITLES.USER_TYPE_MODAL_SUB_TITLE,
        Icons.NEW_PARKER,
        props.isEditMode ? null : getProgressBarValue(ADD_PARKER_FORM_STEPS.USER_TYPE)
      );

      store.dispatch(commonActions.setSideModal({ modalHeader: stepHeader }));
    }
  }, [props]);

  const handleUserTypeChange = (event, userType) => {
    const eventValue = { [INPUTS_PROPS.USER_TYPE]: userType };
    if (userType !== null) {
      setUserTypeValue(userType);
      props.handleChange(eventValue);
    }
  };

  const validateStep = () => {
    setErrors({
      ...errors,
      userTypeValue: isRequired(userTypeValue),
      siteValue: isRequired(siteValue),
    });
  };

  if (
    props.currentStep !== ADD_PARKER_FORM_STEPS.EDIT_STEP &&
    props.currentStep !== ADD_PARKER_FORM_STEPS.USER_TYPE
  ) {
    return null;
  }

  const handleSiteChange = (panel) => (event, isExpanded) => {
    setSiteValue(isExpanded ? panel : false);
    const eventValue = isExpanded
      ? { [INPUTS_PROPS.SITE]: panel }
      : { [INPUTS_PROPS.SITE]: "" };
    props.handleChange({
      ...eventValue,
      [INPUTS_PROPS.TOKENS]: [],
      [INPUTS_PROPS.CAR_USER_TOKEN]: [],
      [INPUTS_PROPS.FOB]: "",
    });
  };

  return (
    <div className={classes.stepContainer}>
      <div className={classes.stepTitle}>
        {Strings.STEPS_TITLES.USER_TYPE_TITLE}
      </div>
      <span className={classes.stepSubTitle}>
        {sitesToShow?.length > 0 ?
           Strings.STEPS_TITLES.USER_TYPE_SUB_TITLE :
           Strings.STEPS_TITLES.USER_TYPE_NO_AVAILABLE_FACILITIES_SUB_TITLE}
      </span>
      {sitesToShow.map((site) => {
        return (
          <Accordion
            key={site.id}
            className={classes.facilitiesContainer}
            expanded={siteValue === site.id}
            onChange={handleSiteChange(site.id)}
          >
            <AccordionSummary
              className={classes.facility}
              expandIcon={
                siteValue === site.id ? (
                  <RadioButtonCheckedIcon className={classes.checked} />
                ) : (
                  <RadioButtonUncheckedIcon />
                )
              }
              aria-controls={site.id}
              id={site.id}
            >
              <FacilityUserTypesCard {...site} />
            </AccordionSummary>
            <AccordionDetails className={classes.userTypesContainer}>
              <UserTypesButtons
                buttonsList={buttonsList}
                selectedValue={userTypeValue}
                handleChange={handleUserTypeChange}
              />
            </AccordionDetails>
          </Accordion>
        );
      })}
    </div>
  );
};

export default UserTypeStep;
